<bn-account-detail-base [product]="product"
                        [hostRef]="hostRef"
                        [productNumberFormat]="productNumberFormat"
                        [title1]="title1"
                        [title2]="title2"
                        [title3]="title3"
                        [title4]="title4">
  <div details>
    <div class="account-detail-base__item">
      <div>
        <strong> {{ translateString("Monto cuota próximo pago", "Next installment amount") }} </strong>
      </div>
      <div>
        {{ product?.additions?.totalFeeAmount | bnCurrencyPipe:product?.additions?.currencyCode }}
        <bn-semaphore-tooltip *ngIf="semaphore.type"
                              [text]="semaphore.text"
                              [type]="semaphore.type"></bn-semaphore-tooltip>
      </div>
    </div>
    <div class="account-detail-base__item">
      <div>
        <strong> {{ translateString("Próxima fecha de pago", "Next installment date") }} </strong>
      </div>
      <div *ngIf="product?.minimumPaymentDueDate != -1">{{ product?.minimumPaymentDueDate | bnEsDate }}</div>
      <div *ngIf="!product?.minimumPaymentDueDate || product?.minimumPaymentDueDate == -1">--</div>
    </div>
    <div class="account-detail-base__item">
      <div>
        <strong> {{ translateString("Fecha último pago", "Last installment date") }} </strong>
      </div>
      <div>{{ product?.additions?.lastPmtDate | bnEsDate }}</div>
    </div>
  </div>

  <div row2
       class="row">
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong> {{ translateString("Capital", "Capital") }} </strong></div>
        <div>{{ product?.additions?.capitalFee | bnCurrencyPipe:product?.additions?.currencyCode }}</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong> {{ translateString("Mora", "Late payment") }} </strong></div>
        <div *ngIf="product?.accountInterestRate != -1">
          {{ product?.additions?.amountOfArrears | bnCurrencyPipe:product?.additions?.currencyCode }}</div>
        <div *ngIf="product?.accountInterestRate == -1">--</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong> {{ translateString("Interés", "Interest") }} </strong></div>
        <div>{{ product?.additions?.interests | bnCurrencyPipe:product?.additions?.currencyCode }}</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong> {{ translateString("Seguros/Otros cargos", "Insurances/Other charges") }} </strong></div>
        <div>{{ product?.additions?.otherChargesAmount | bnCurrencyPipe:product?.additions?.currencyCode }}</div>
      </div>
    </div>
  </div>

  <div row3
       class="row">
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong> {{ translateString("Monto total vencido", "Total overdue amount") }} </strong></div>
        <div>{{ product?.additions?.totalFeeAmountDue | bnCurrencyPipe:product?.additions?.currencyCode }}</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong> {{ translateString("Días de mora", "Late payment days") }} </strong></div>
        <div>{{ product?.additions?.daysPastDue == -1 ? '--' : product?.additions?.daysPastDue | bnDigit }}</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong> {{ translateString("Nº cuotas vencidas", "Overdue installments") }} </strong></div>
        <div>{{ product?.additions?.expiredFees == -1 ? '--' : product?.additions?.expiredFees | bnDigit }}</div>
      </div>
    </div>
  </div>

  <div row4
       class="row">
    <div class="col-md-6">
      <div class="account-detail-base__item account-detail-base__item--blue">
        <div><strong> {{ translateString("Monto desembolso", "Initial amount") }} </strong></div>
        <div>{{ product?.additions?.originalAmount | bnCurrencyPipe:product?.additions?.currencyCode }}</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong> {{ translateString("Fecha desembolso", "Start date") }} </strong></div>
        <div>{{ product?.additions?.startDate | bnEsDate }}</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong> {{ translateString("Monto cuota regular", "Installment amount") }} </strong></div>
        <div>{{ product?.additions?.financialFeeAmount | bnCurrencyPipe:product?.additions?.currencyCode }}</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong> {{ translateString("Tasa de interés", "Interest rate") }} </strong></div>
        <div>{{ product?.accountInterestRate | number }}%</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong> {{ translateString("Cuotas pagadas", "Paid installments") }} </strong></div>
        <div>{{ product?.additions?.feesPaid == -1 ? '--' : product?.additions?.feesPaid | bnDigit }}</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong> {{ translateString("Plazo", "Term") }} </strong></div>
        <div>{{ product?.termNumber }} {{ product?.termUnit }}</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong> {{ translateString("Fecha vencimiento", "Maturity date") }} </strong></div>
        <div>
          {{ !product?.maturityDate || product?.maturityDate == -1 ? '--' : product?.maturityDate | bnEsDate }}
        </div>
      </div>
      <div class="account-detail-base__item">
        <div><strong> {{ translateString("Balance capital", "Outstanding balance") }} </strong></div>
        <div>{{ product?.additions?.amoutOfCapitalTotal | bnCurrencyPipe:product?.additions?.currencyCode }}</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong> {{ translateString("Estatus del préstamo", "Loan status") }} </strong></div>
        <div>{{ product?.additions?.accountStatus == -1 ? '--' : product?.additions?.accountStatus }}</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong> {{ translateString("N° cuotas pendientes", "Pending installments") }} </strong></div>
        <div>{{ product?.additions?.pendingFees == -1 ? '--' : product?.additions?.pendingFees | bnDigit }}</div>
      </div>
    </div>
  </div>
</bn-account-detail-base>
